import { CSSObject } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

// TODO: both might need to be change in the future when dark theme is re-defined.
export const rw1MainBackgroundImage = (props: Dict): CSSObject => ({
  backgroundImage: mode(
    'linear-gradient(180deg, #288BFE 0%, #0C6FE2 100%)',
    'linear-gradient(180deg, #288BFE 0%, #0C6FE2 100%)',
  )(props),
})

export const progressBarBackgroundImage = (props: Dict): CSSObject => ({
  backgroundImage: mode(
    'linear-gradient(#0C6FE2, #52A2FF)',
    'linear-gradient(#0C6FE2, #52A2FF)'
  )(props),
  animationDuration: "5s!important"
})


export const rw1MainBackgroundImageAction = (props: Dict): CSSObject => ({
  backgroundImage: mode(
    'linear-gradient(180deg, #0C6FE2 0%, #288BFE 100%)',
    'linear-gradient(180deg, #0C6FE2 0%, #288BFE 100%)',
  )(props),
})
